import { render } from "./AdvancedReport.vue?vue&type=template&id=df54568a&scoped=true&ts=true"
import script from "./AdvancedReport.vue?vue&type=script&lang=ts"
export * from "./AdvancedReport.vue?vue&type=script&lang=ts"

import "./AdvancedReport.vue?vue&type=style&index=0&id=df54568a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df54568a"]])

export default __exports__